$(document).ready(function() {

	// Переносим SEO-текст из header в footer
	$("#s-footer-block").html($("#s-header-block").html());
	$("#s-header-block").remove();

	// Табы в карточке продукта
	$(".tabbar .i-tab").on('click', function() {
		var $this = $(this);
		$(".tabbar .i-tab").removeClass('active');
		$this.addClass('active');

		var tab = $this.attr('href').replace('#', '');
		$('[data-tab]').fadeOut(200);
		setTimeout(function() {
			$('[data-tab="' + tab + '"]').fadeIn(200);
		}, 200);
	});

	if (window.location.hash) {
		var tab = window.location.hash;
		if(/tab/.test(tab)) {
			$('.tabbar .i-tab').removeClass('active');
			$('[href="' + tab + '"]').addClass('active');
			tab = tab.replace('#', '');
			$('[data-tab]').hide();
			$('[data-tab="' + tab + '"]').show();
		}
	}

	// Поиск

	$.widget( "custom.catcomplete", $.ui.autocomplete, {
		_create: function() {
		  this._super();
		  this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
		},
		_renderMenu: function( ul, items ) {
			var that = this,
				currentCategory = "";
			$.each( items, function( index, item ) {
				var li;
				if ( item.category != currentCategory ) {
					ul.append( "<li class='ui-autocomplete-category'>" + item.category + "</li>" );
					currentCategory = item.category;
				}
				li = that._renderItemData( ul, item );
				if ( item.category ) {
					li.attr( "aria-label", item.category + " : " + item.label );
				}
			});
		}
	});

	var cache = {};
	$( "#main-search" ).catcomplete({
	  source: function( request, response ) {
		var term = request.term;
		if ( term in cache ) {
		  response( cache[ term ] );
		  return;
		}

		$.ajax({
		  url: "/",
		  dataType: "json",
		  data: {
			q: request.term
		  },
		  success: function( data ) {
			cache[ term ] = data;
			response( data );
		  }
		});
	  },
	  minLength: 2,
	  select: function( event, ui ) {
		if (ui.item.category == 'Разделы:')
			window.location.href = "/catalog/category/" + (ui.item.human_url || ui.item.id) + '/';

		if (ui.item.category == 'Товары:')
			window.location.href = "/catalog/product/" + ui.item.id + '/';

		if (ui.item.category == 'Страницы:')
			window.location.href = "/page/" + ui.item.id + '/';

		if (ui.item.category == 'Статьи:')
			window.location.href = "/article/" + ui.item.id + '/';
	  },
	  open: function() {
		$( this ).removeClass( "ui-corner-all" ).addClass( "ui-corner-top" );
	  },
	  close: function() {
		$( this ).removeClass( "ui-corner-top" ).addClass( "ui-corner-all" );
	  }
	}).catcomplete( "instance" )._renderItem = function( ul, item ) {
		var arrTerm = [];
		arrTerm = this.term.split(/\s+/gi);

		each(arrTerm, function (i, el) {
			var re = new RegExp('(' + trim(el) + ')(?!>)', "gi");
			if (item.label && trim(el))
				item.label = item.label.replace(re, "<b>$1</b>");
		});

		if (item.category == 'Товары:') {
			return $( "<li>" )
				.append( tmpl($('#search-item-ejs').html(), item) )
				.appendTo( ul );
		} else if (item.category == 'Разделы:') {
			if (!item.human_url)
				item.human_url = undefined;
			return $( "<li>" )
				.append( tmpl($('#search-category-ejs').html(), item) )
				.appendTo( ul );
		} else if (item.category == 'Страницы:') {
			return $( "<li>" )
				.append( tmpl($('#search-page-ejs').html(), item) )
				.appendTo( ul );
		} else if (item.category == 'Статьи:') {
			return $( "<li>" )
				.append( tmpl($('#search-article-ejs').html(), item) )
				.appendTo( ul );
		}
	};

	/* Enable fancyBox */
	$(".fancybox").fancybox();


	/**** Start Сравнение ****/

	function checkCompareList() {
		if (!store.enabled) {
			return;
		}

		var compare = store.get('compare');

		var $compare_block = $(".rUti.mx_compare");
		var $compare_list = $compare_block.find(".i-list");
		$compare_list.html('');

		if (compare && Object.keys(compare).length) {
			$(".rUti.mx_compare").show();
			// Количество товаров, добавленных к сравнению
			$compare_block.find(".i-count").html(Object.keys(compare).length);

			// Формируем контент всплывающего блока сравнения
			each(Object.keys(compare), function (i, el) {
				var li = ce("li", {className: "i-item"});
				var a = ce("a", {
					href: "/catalog/product/" + el + "/",
					innerHTML: compare[el].title,
					target: "_blank"
				});
				var price = ce("span", {
					innerHTML: compare[el].price + ' <i class="rub">i</i>',
					className: 'ws_n'
				});

				var button_del = ce("div", {
					className: 'button mx_fdel'
				});

				var act_hover = ce("div", {
					className: "act_hover"
				});

				$(button_del).append(act_hover);
				$(button_del).data("id", el);

				$(li).append(button_del);
				$(li).append(a);
				// $(li).append(price);

				$compare_list.append(li);
			});
		} else {
			$(".rUti.mx_compare").hide();
		}

		// Ссылки Добавить/Добавлено к сравнению
		$(".incompare.link").each(function (i, el) {
			var $el = $(el);

			// Если товар добавлен к сравнению, то показываем блок, что он добавлен
			if (compare && compare[$el.data("id")]) {
				$el.find(".add_block").hide();
				$el.find(".added_block").show();
				$el.find(".count").html(Object.keys(compare).length);
			} else {
				$el.find(".add_block").show();
				$el.find(".added_block").hide();
			}
		});
	}

	// Проверка добавленных к сравнению продуктов
	checkCompareList();

	// Добавление в список сравнения
	$(".incompare.link").on("click", ".add_link", function () {
		var $this = $(this);

		if (!store.enabled) {
			alert('Данная функция не поддерживается Вашим браузером. Пожалуйста, отключите "Приватный режим", или установите интернет-браузер последней версии.')
			return;
		}

		var $compare_block = $this.closest(".incompare.link");
		var product = $compare_block.data();
		var id = product.id;

		var compare = store.get('compare');

		if (!compare)
			compare = {};

		if (!compare[id]) {
			compare[id] = product;

			store.set("compare", compare);

			checkCompareList();
		}
	});

	// Удаление из списка сравнения
	$(".incompare.link").on("click", ".delete_link", function () {
		var $this = $(this);

		if (!store.enabled) {
			alert('Данная функция не поддерживается Вашим браузером. Пожалуйста, отключите "Приватный режим", или установите интернет-браузер последней версии.')
			return;
		}

		var $compare_block = $this.closest(".incompare.link");
		var id = $compare_block.data("id");

		var compare = store.get('compare');
		if (!compare)
			return;

		delete compare[id];
		store.set("compare", compare);

		checkCompareList();
	});

	// Удаление из списка сравнения на странице сравнения
	$(".compare").on("click", ".mx_remove.i-remove", function () {
		var $this = $(this);

		if (!store.enabled) {
			alert('Данная функция не поддерживается Вашим браузером. Пожалуйста, отключите "Приватный режим", или установите интернет-браузер последней версии.')
			return;
		}

		var id = $(this).data("id");

		var compare = store.get('compare');
		if (!compare)
			return;

		delete compare[id];
		store.set("compare", compare);

		window.location = "/compare/index.html?cmp=" + Object.keys(compare).join(',');
	});

	// Удаление из списка сравнения в блоке сравнения
	$(".mx_compare").on("click", ".mx_fdel", function () {
		var $this = $(this);

		if (!store.enabled) {
			alert('Данная функция не поддерживается Вашим браузером. Пожалуйста, отключите "Приватный режим", или установите интернет-браузер последней версии.')
			return;
		}

		var id = $(this).data("id");

		var compare = store.get('compare');
		if (!compare)
			return;

		delete compare[id];
		store.set("compare", compare);

		checkCompareList();
	});

	// Редирект на страницу сравнения
	$(document).on("click", ".compare_link", function () {
		var $this = $(this);

		if (!store.enabled) {
			alert('Данная функция не поддерживается Вашим браузером. Пожалуйста, отключите "Приватный режим", или установите интернет-браузер последней версии.')
			return;
		}

		var compare = store.get('compare');
		if (!compare)
			return;

		window.location = "/compare/index.html?cmp=" + Object.keys(compare).join(',');
	});

	$(".mx_compare").on("click", ".rUti__min.active", function () {
		var $this = $(this);

		if (!store.enabled) {
			alert('Данная функция не поддерживается Вашим браузером. Пожалуйста, отключите "Приватный режим", или установите интернет-браузер последней версии.')
			return;
		}

		var compare = store.get('compare');
		if (!compare)
			return;

		window.location = "/compare/index.html?cmp=" + Object.keys(compare).join(',');
	});

	// Отобразить различающиеся параметры
	$(".compare .not_same_params").on("click", function () {
		var $this = $(this);
		$this.parent().find(".i-item").removeClass("active");
		$this.addClass("active");
		$(".compare .i-line.i-same").hide();
	});

	// Отобразить все параметры
	$(".compare .all_params").on("click", function () {
		var $this = $(this);
		$this.parent().find(".i-item").removeClass("active");
		$this.addClass("active");
		$(".compare .i-line.i-same").show();
	});

	/**** End Сравнение ****/
	var promodiscount = $("#promodiscount").val() || 0;

	// Найденный город при автодополнении поля "Город"
	var found_city;
	var free_delivery = $("#free_delivery").val();
	if ($("#total_price").val() < 5000)
		free_delivery = 0;

	// Автодополнение поля "Город"
	if ($(".city_input").length > 0) {
		$('.city_input').autocomplete({
			serviceUrl: '/shopcart/index.html',
			onSelect: citySelect,
			params: {get_city_list: 1},
			deferRequestBy: 100
		});
	}

	$(".city_input").focus().blur();

	$(document).on("keyup blur change", '.city_input', function (argument) {
		var delivery_price = 0;
		var total_price = $("#total_price").val();

		// Если при вводе названия города, он не найден в базе, то показываем блок уточнения доставки
		if ($(this).val() != found_city) {
			$("#delivery_block").hide();
			$("#delivery_free").hide();
			if ($(this).val())
				$("#delivery_clarify").show();
			else
				$("#delivery_clarify").hide();

			$("#delivery_express_block").removeClass('hidden');
			$("#delivery_ratio").val('');
		} else if (free_delivery && $("input[name='id_delivery']:checked").val() != 5) {
			$("#delivery_block").hide();
			$("#delivery_free").show();
			$("#delivery_clarify").hide();
			$("#delivery_express_block").removeClass('hidden');
			$("#delivery_ratio").val('');
		} else {
			//delivery_price = $("input[name='id_delivery']:checked").data("price");
			if ($("input[name='id_delivery']:checked").val() == 5) {
				delivery_price = $("#courier").data("price");
			}
			var ratio    = $("#delivery_ratio").val();
			var km_price = $("#delivery_km_price").val();
			// Получаем цену доставки
			delivery_price += intval(ratio * km_price);
			$("#delivery_free").hide();

			// Если сумма меньше 5000 руб., то обычная доставка +400 руб.
			if ($("input[name='id_delivery']:checked").val() == 1 && intval(total_price) < 5000 && intval(ratio) === 0) delivery_price += 400;

			// Для городов, расстояние до которых больше 90 км, нет экспресс-доставки
			if (ratio >= 90) {
				$("input[name='id_delivery']").prop('checked', false);
				$($("input[name='id_delivery']")[0]).prop('checked', true);
				$("#delivery_express_block").addClass('hidden');
				$("#courier").click();
			} else {
				$("#delivery_express_block").removeClass('hidden');
			}
		}

		$("#delivery_price").val(delivery_price);
		total_price = intval(total_price) + intval(delivery_price) - promodiscount;
		$("#total_price_value").html(total_price);
		$("#i-total").html(total_price);
	});

	function citySelect (suggestion) {
		$("#delivery_ratio").val(suggestion.ratio);
		// Запоминаем найденный город
		found_city = suggestion.value;
		free_delivery = suggestion.free_delivery;
		if ($("#total_price").val() < 5000)
			free_delivery = 0;
		$("input[name='id_delivery']:checked").click();

		// Показываем блок доставки
		if (free_delivery && $("input[name='id_delivery']:checked").val() != 5) {
			$("#delivery_free").show();
			$("#delivery_block").hide();
			$("#delivery_price").val(0);
		} else {
			$("#delivery_block").show();
			$("#delivery_free").hide();
		}
		// Скрываем блок уточнения доставки менеджером
		$("#delivery_clarify").hide();
	}

	$(".mx_cart").on("click", ".rUti__min.active", function () {
		window.location = "/shopcart/";
	});

	$(".mx_search, .mx_m-search").on("click", function () {
		$(this).closest('form').submit();
	});

	$(document).on("click", "#cart-support", function () {
		if($(this).is(':checked')) {
		   $.cookie('service', 1, { expires: 1, path: '/' });
		} else {
		   $.removeCookie('service', { path: '/' });
		}
	});

	// Галочка подтверждения с ознакомлением условий продажи и правовой информации
	$(document).on("click", "#rules", function () {
		if($(this).is(':checked')) {
			if (checkRequiredFields()) {
				$(".mx_submit-order").removeClass("mx_disabled");
			} else {
				$.jGrowl("Заполните обязательные поля");
				$(".mx_submit-order").addClass("mx_disabled");
			}
		} else {
			$(".mx_submit-order").addClass("mx_disabled");
		}
	});

	// Кнопка "Подтвердить заказ"
	$(document).on("click", ".mx_submit-order", function (e) {
		if ($("#rules").prop('checked') && !checkRequiredFields()) {
			$.jGrowl("Заполните обязательные поля");
			$(".mx_submit-order").addClass("mx_disabled");
			e.preventDefault();
			return;
		}

		if($(this).hasClass('mx_disabled')) {
			e.preventDefault();
		   return;
		}
	});

	// Проверка required полей во время blur
	$(document).on('blur', ".i-required", function() {
		if ($("#rules").prop('checked') && checkRequiredFields()) {
			$(".mx_submit-order").removeClass("mx_disabled");
		} else {
			$(".mx_submit-order").addClass("mx_disabled");
		}
	});

	if ($.cookie('service')) {
		$("#cart-support").prop("checked", true);

		$("#customer_service_block").show();
		$("#customer_service").val(1);
	}

	// Страница оформления заказа, смена radiobutton в блоке "Доставка"
	$("input[name='id_delivery']").on("click", function () {
		var price = 0; // начальная цена доставки

		// Если выбрана экспресс-доставка, то начальая цена - 400 руб.
		if ($("input[name='id_delivery']:checked").val() == 5) {
			price = 400;
		}

		var ratio    = $("#delivery_ratio").val();    // количество километров до города
		var km_price = $("#delivery_km_price").val(); // цена за километр

		// Для городов, расстояние до которых больше 90 км, нет экспресс-доставки
		if (ratio && ratio >= 90 && !$("#delivery_express_block").hasClass('hidden')) {
			$("input[name='id_delivery']").prop('checked', false);
			$($("input[name='id_delivery']")[0]).prop('checked', true);
			$("#delivery_express_block").addClass('hidden');
		}

		// Получаем цену доставки с учетом расстояния
		price += (ratio * km_price);

		var total_price = $("#total_price").val(); // стоимость заказа

		if (free_delivery && $(this).val() == 5) {
			price = 400;
		}

		promodiscount = intval(promodiscount);
		total_price   = intval(total_price);

		// Если сумма меньше 5000 руб., то обычная доставка +400 руб.
		if (($(this).val() == 1 || $(this).val() == 5) && intval(total_price) < 5000 && intval(ratio) === 0) price += 400;

		// Если самовывоз
		if ($(this).val() == 2) {
			// Скрываем все блоки с доставкой
			$("#delivery_block, .user-address, #delivery_clarify, #delivery_free").hide();
			if (total_price >= 5000 && !promodiscount) $("#pickup_discount").show();
			else $("#pickup_discount").hide();
			price = 0;

		// Показываем блок с доставкой и записываем в него цену
		} else {
			$("#pickup_discount").hide();
			// Если в поле "Город" указан найденный в базе город
			if ($(".city_input").val() == found_city) {
				// Показываем блок с доставкой
				$(".user-address").show();
				if (!free_delivery || $(this).val() == 5) {
					$("#delivery_block").show();
					$("#delivery_free").hide();
				} else {
					$("#delivery_block").hide();
					$("#delivery_free").show();
				}
				// Скрываем блок уточнения доставки
				$("#delivery_clarify").hide();
			// Если указанный город не найден в базе
			} else {
				// Показываем блок уточнения доставки
				$(".user-address").show();
				if ($('[name="city"]').val())
					$("#delivery_clarify").show();
				else
					$("#delivery_clarify").hide();
				// Скрываем блок доставки
				$("#delivery_block").hide();
				price = 0;
			}
			$("#delivery_block .i-price").html(price);
		}

		// Если доставка бесплатная и не выбрана экспресс-доставка
		if (free_delivery && $(this).val() != 5) {
			price = 0;
		} else if (free_delivery && $(this).val() == 5) {
			price = 400;
		}

		// Скидка на самовывоз
		if ($(this).val() == 2 && intval(total_price) >= 5000 && !promodiscount) price = -500;

		$("#delivery_price").val(price);
		total_price = intval(total_price) + intval(price) - promodiscount;
		$("#total_price_value").html(total_price);
		$("#i-total").html(total_price);

		// Переносим значения полей адреса из блока "Доставка курьерской службы" в блок "Экспресс доставка"
		if ($(this).val() == 1 && $("#delivery_express .i-form").length != 0) {
			$("#delivery_courier").html($("#delivery_express").html());

			$("#delivery_express input").each(function (i, el) {
				var name = $(el).attr('name');
				$("#delivery_courier input[name='" + name + "']")
					.val($(el).val())
					.attr("class", $(el).attr("class"));
			});

			$("#delivery_express textarea").each(function (i, el) {
				var name = $(el).attr('name');
				$("#delivery_courier textarea[name='" + name + "']")
					.val($(el).val())
					.attr("class", $(el).attr("class"));
			});

			$("#delivery_express").html('');
		}

		if ($(this).val() == 5 && $("#delivery_courier .i-form").length != 0) {
			$("#delivery_express").html($("#delivery_courier").html());

			$("#delivery_courier input").each(function (i, el) {
				var name = $(el).attr('name');
				$("#delivery_express input[name='" + name + "']")
					.val($(el).val())
					.attr("class", $(el).attr("class"));
			});

			$("#delivery_courier textarea").each(function (i, el) {
				var name = $(el).attr('name');
				$("#delivery_express textarea[name='" + name + "']")
					.val($(el).val())
					.attr("class", $(el).attr("class"));
			});

			$("#delivery_courier").html('');
		}

		$('.city_input').autocomplete({
			serviceUrl: '/shopcart/index.html',
			onSelect: citySelect,
			params: {get_city_list: 1},
			deferRequestBy: 100
		});
	});

	/** Функция для показа всплывающего окна с сообщением о минимальной цене */
	var showMinPriceMessage = (function () {
		// static
		var timeout,
			$popup = $('.i-minprice-msg');

		return function() {
			$popup.fadeIn(200);
			clearTimeout(timeout);
			timeout = setTimeout(function() {
				$popup.fadeOut(200);
			}, 7000);
		};
	})();
	// Закрытие всплывающей подсказки с сообщением
	$('.i-popup-message .i-close').on('click', function(){
		$(this).closest('.i-popup-message').fadeOut(200);
	});

	// Кнопка "Оформить заказ"
	$('.mx_checkout').on('click', function(){
		var total_price = $('[data-total-price]').data('total-price');
		if (total_price < 5000) {
			showMinPriceMessage();
		} else {
			window.location.href = '/shopcart/index.html?ordering=1';
		}
	});

	var yaCounter_zakaz = new Ya.Metrika({id: 25219640});
	$(document).on('click', '.btn_buy_one_click', function () {
		var $btn = $(this);
		if ($btn.hasClass('disabled')) return;

		if ($btn.data('price') < 5000) {
			showMinPriceMessage();
			return;
		}

		var flag_error = 0;
		if (!$("#user_name").val()) {
			flag_error = 1;
		}

		var re = /^\+\d+\(\d+\)\d+-\d+-\d+$/;
		if (!$("#user_phone").val() || val($("#user_phone")[0]).length < 11 ) {
			flag_error = 1;
		}

		if (flag_error) {
			$.jGrowl("Введите, пожалуйста, все данные");
			return;
		}

		if (!$btn.hasClass('disabled')) {
			$btn.addClass("disabled");
			$btn.find('img').show();

			yaCounter_zakaz.reachGoal('pokupka_v_klik');
			ga('send', 'event', 'button_pokupka_v_klik', 'click_pokupka_v_klik');

			if ($btn.data("id")) {
				var d = shopCart.update($btn.data("id"));
				d.done(function () {
					var confirm = shopCart.confirmOrder($btn.closest('form')[0], $btn.data("id"));
					modal_close();
					confirm.done(function() {
						$btn.removeClass("disabled");
						$btn.find('img').hide();
					});
				});
			}
		}
	});

	// popup
	$('[data-popup-button]').on('click', function(){
		popup_open($(this).attr('data-popup-button'));
	});
	$('[data-popup-close]').on('click', function(){
		popup_close($(this).attr('data-popup-close'));
	});
	function popup_open(id){
		$('[data-popup='+ id +']').fadeIn(200, function(){
			//$(this).addClass('show');
		});
	}
	function popup_close(id){
		$('[data-popup='+ id +']').fadeOut(300, function(){
			//$(this).removeClass('show');
		});
	}

	// sort
	$('[data-sort-item]').on('click', function(){
		var id = $(this).closest('[data-sort-list]').attr('data-sort-list');

		$(this).closest('[data-sort-list]').find('[data-sort-item]').removeClass('active');
		$(this).addClass('active');


		$('[data-sort-select='+ id +']').html($(this).attr('data-sort-item'));
		popup_close(id);
	});

	// right util element
	$(document).on('click', '[data-ruti-min]', function(){
		if($(this).hasClass('active')){

		}else{
			var obj = $(this).closest('[data-ruti]');
			obj.find('[data-ruti-min]').toggleClass('active');
			rUti_open(obj);
		}
	});

	$(document).on('click', '[data-ruti-close]', function(){
		var obj = $(this).closest('[data-ruti]');
		obj.find('[data-ruti-min]').toggleClass('active');
		rUti_close(obj);
	});

	// show\hide password
	$('[data-pass-show]').on({
		click: function(){
			var origPass = $(this).parent().find('input');
			var textPass = origPass.clone();
			if($(this).hasClass('active')){
				textPass.attr("type", "password").insertBefore(origPass);
				origPass.remove();
				$(this).removeClass('active');
			}else{
				textPass.attr("type", "text").insertBefore(origPass);
				origPass.remove();
				$(this).addClass('active');
			}
		}
	});

	// filter range
	$('[data-range]').each(function(){

		var min = intval($('[data-range-min]', this).attr('data-range-min')),
			max = intval($('[data-range-max]', this).attr('data-range-max')),
			left = intval($('[data-range-min]', this).val()),
			right = intval($('[data-range-max]', this).val());

		$('[data-range-slider]', this).slider({
			min: min,
			max: max,
			values: [left,right],
			//step: $(this).attr('data-range-step'),
			range: true,
			create: function(event, ui) {
				$(this).closest('[data-range]').find('[data-range-min]').val($(this).slider( "values", 0 ));
				$(this).closest('[data-range]').find('[data-range-max]').val($(this).slider( "values", 1 ));
			},
			stop: function(event, ui) {
				$(this).closest('[data-range]').find('[data-range-min]').val($(this).slider( "values", 0 ));
				$(this).closest('[data-range]').find('[data-range-max]').val($(this).slider( "values", 1 ));
			},
			slide: function(event, ui){
				$(this).closest('[data-range]').find('[data-range-min]').val($(this).slider( "values", 0 ));
				$(this).closest('[data-range]').find('[data-range-max]').val($(this).slider( "values", 1 ));

				triggerEvent($(".filter")[0], 'search', $(this));
			}
		});

	});

	// Выбор категории в фильтре
	$('.filter__category').on("click", '.i-item', function (event) {
		var $this = $(this);

		if ($(event.target).hasClass('act_hover'))
			return;

		if ($this.data('all')) {
			$('.filter__category .i-point').removeClass('active');
			$this.find('.i-point').addClass('active');
		} else {
			$('.filter__category [data-all] .i-point').removeClass('active');
			$this.find('.i-point').addClass('active');
		}

		triggerEvent($(".filter")[0], 'search', $this);
	});

	// Удаление категории из фильтра
	$('.filter__category').on("click", '.mx_fdel', function (argument) {
		var $this = $(this);

		$this.parent().removeClass('active');

		if (!$(".filter__category .i-point.active").length) {
			$(".filter__category [data-all]").find('.i-point').addClass('active');
		}

		triggerEvent($(".filter")[0], 'search', $this);
	});

	$('.filter__block .i-input').on('textchange', function (argument) {
		triggerEvent($(".filter")[0], 'search', $(this));
	});

	// Выбор бренда в фильре
	$(".filter__checklist .checkbox").on('check', function (argument) {
		var $this = $(this);
		var check = $this.find('input').prop('checked');

		if ($this.data('all')) {
			$this.closest('.filter__checklist').find('input').prop('checked', false);
			$this.closest('.filter__checklist').find('.checkbox').removeClass('checked');
			$this.find('input').prop('checked', check);
			$this.addClass('checked');
		} else {
			$this.closest('.filter__checklist').find('[data-all] input').prop('checked', false);
			$this.closest('.filter__checklist').find('[data-all]').removeClass('checked');
		}

		// var $btn_more = $this.closest('.filter__checklist').find('.i-more');
		// if (!$btn_more.hasClass('opened')) {
		// 	$btn_more.click();
		// }

		triggerEvent($(".filter")[0], 'search', $(this));
	});

	var searchFilterTimeout;
	var filterCounterTimeout;
	var filter_href;
	// Когда меняются параметры в фильтре
	$(".filter").on('search', function (event) {
		// Объект, от которого возникло событие
		var $filterObject = $(event.originalEvent.addData);

		clearTimeout(searchFilterTimeout);
		searchFilterTimeout = setTimeout(function (argument) {

			var arg = {};
			arg.json = JSON.stringify(serializeFilters($('.filter')[0]));
			arg.search_product_count = 1;

			if (/discount/.test(window.location.href))
				arg.discount = 1;

			$.post('/catalog/index.html', arg, function (data) {
				if (data != null) {
					data = $.parseJSON(data);

					// Счетчик найденных продуктов
					var $filterCounter = $filterObject.closest('.filter__block').find('.filter__counter');
					$filterCounter.find('.link span').html(data.count);
					var href = window.location.href.replace(/filter=.*/, '');
					href = href.replace(/\/page\/\d+\//, '/page/1/');
					filter_href = href + 'filter=' + Base64.encode(encodeURIComponent(arg.json));
					$filterCounter.find('a').attr('href', filter_href);

					// Показываем подсказку "Найдено N моделей"
					if ($filterObject.hasClass('mx_fdel') && !$(".filter__category .active").length) {
						$filterCounter.fadeOut(200);
					} else {
						// Прячем счетчики найденных продуктов в других блоках
						if ($filterCounter.css('display') == 'none') {
							$('.filter__counter').fadeOut(100);
						}
						$filterCounter.fadeIn(200);
						clearTimeout(filterCounterTimeout);
						filterCounterTimeout = setTimeout(function (argument) {
							$filterCounter.fadeOut(200);
						}, 4000);
					}
				}
			});

		}, 300);
	});

	$(".filter .button.mx_show").on('click', function (argument) {
		if (filter_href)
			window.location.href = filter_href;
	});

	$(".filter .btn-filter-toggle").on('click', function(){
		var $this = $(this);
		if ($this.hasClass('opened')) {
			$this.parent().siblings('div.filter__checklist').slideUp(100);
			$this.parent().siblings('div.filter__range').slideUp(100);
			$this.removeClass('opened');
		} else {
			$this.addClass('opened');
			$this.parent().siblings('div.filter__checklist').slideDown(100);
			$this.parent().siblings('div.filter__range').slideDown(100);
		}
	});

	$(".filter .i-more").on('click', function(){
		var $this = $(this);
		if ($this.hasClass('opened')) {
			$this.siblings('div').slideUp(100);
			$this.html('Показать еще');
			$this.removeClass('opened');
		} else {
			$this.addClass('opened');
			$this.html('Скрыть');
			$this.siblings('div').slideDown(100);
		}
	});

	// Сбрасываем фильтры при нажатии на "Очистить"
	$(".filter .btn-filter-clear").on('click', function(){
		// $('.filter__checklist input').prop('checked', false);
		// $('.filter__checklist .checkbox').removeClass('checked');

		// $('[data-range]').each(function(){
		// 	var min = intval($('[data-range-min]', this).attr('data-range-min')),
		// 		max = intval($('[data-range-max]', this).attr('data-range-max'));

		// 	$('[data-range-min]', this).val(min);
		// 	$('[data-range-max]', this).val(max);

		// 	$('[data-range-slider]', this).slider("values", 0, min);
		// 	$('[data-range-slider]', this).slider("values", 1, max);
		// });

		// triggerEvent($(".filter")[0], 'search', $(this));

		var url = window.location.href;
		url = url.replace(/(filter=.*)/, '');
		window.location.href = url;
	});

	/** Функция для сбора значений фильтров */
	function serializeFilters (div) {
		var param = serializeForm($(div)[0]);
		var filter_checked = 0;
		if (!param)
			param = {};

		param.filter_category = [];
		$('.filter_category_block .i-link.active').each(function (i, el) {
			if ($(el).data('id')) {
				param.filter_category.push($(el).data('id'));
			}
		});

		if (!param.filter_category.length && $('#current_category').val() && $('#current_brand').val()) {
			param.filter_parent_category = [];
			param.filter_parent_category.push($('#current_category').val());
		}

		if (!param.filter_category.length && $('#current_category').val() && !$('#current_brand').val()) {
			param.filter_category.push($('#current_category').val());
		}

		param.filter_brand = [];
		$('.filter__brand input:checked').each(function (i, el) {
			if ($(el).parent().data('id')) {
				param.filter_brand.push($(el).parent().data('id'));
				filter_checked = 1;
			}
		});

		param.filter_balance = [];
		$('.filter__balance input:checked').each(function (i, el) {
			if ($(el).parent().data('id')) {
				param.filter_balance.push($(el).parent().data('id'));
				filter_checked = 1;
			}
		});

		param.filter_status = [];
		$('.filter__status input:checked').each(function (i, el) {
			if ($(el).parent().data('id')) {
				param.filter_status.push($(el).parent().data('id'));
				filter_checked = 1;
			}
		});

		$('.filter_param_str').each(function(i, el){
			var param_id = $(el).data('id');
			$(el).find('input:checked').each(function(i, chk){
				if ($(chk).parent().data('value')) {
					if (!param['filter_param_' + param_id])
						param['filter_param_' + param_id] = [];
					param['filter_param_' + param_id].push($(chk).parent().data('value'));
					filter_checked = 1;
				}
			});
		});

		$('[data-range-min]').each(function(i, el){
			if ($(el).data('range-min') != $(el).val()) {
				param['filter_from_param_' + $(el).data('id')] = $(el).val();
				filter_checked = 1;
			}
		});

		$('[data-range-max]').each(function(i, el){
			if ($(el).data('range-max') != $(el).val()) {
				param['filter_to_param_' + $(el).data('id')] = $(el).val();
				filter_checked = 1;
			}
		});

		// Показываем кнопку "Очистить фильтр"
		if (filter_checked) {
			$('.filter_top_clear_block, .filter_bottom_clear_block').removeClass('hidden');
		} else {
			$('.filter_top_clear_block, .filter_bottom_clear_block').addClass('hidden');
		}

		return param;
	}

	// checkbox
	$.each($('.checkbox'),function(){
			if($('input', this).is(':checked')){
				$(this).addClass('checked');
			}
		}
	);
	$('.checkbox').on('click', function(){
			$(this).toggleClass('checked');
			var path = $('input', this);
			if(path.prop('checked')) {
				path.prop('checked', false);
			}else{
				path.prop('checked', true);
			}

			triggerEvent($(this)[0], 'check');
		}
	);

	// menu structure
	$.each($('.menu__item'), function(){
		$('.menu__drop', this).find('.i-arrow').css({
			'left': $(this).width()/2
		})
	});

	// modal
	$('[data-modal-button]').on('click', function(){
		var id = $(this).attr('data-modal-button');
		modal_open(id);
	});
	$('[data-modal-close]').on('click', function(){
		modal_close();
	});
	$('.overlay').on('click', function(){
		modal_close();
	});

	// filter checklist more
	$('[data-filter-more]').on('click', function(){
		if($(this).hasClass('active')){
			var i = 0;
			$(this).closest('.filter__checklist').find('.i-item').each(function(i){
				if(i > 4){
					$(this).hide(100);
				}
				i++;
			});
			$(this).removeClass('active');
		}else{
			$(this).closest('.filter__checklist').find('.i-item').show(100);
			$(this).addClass('active');
		}
	});

	// product counter
	$('[data-counter-plus]').on('click', function(){
		paramValuePlus($(this).closest('[data-counter]'))
	});
	$('[data-counter-minus]').on('click', function(){
		paramValueMinus($(this).closest('[data-counter]'))
	});
	function paramValuePlus(param){
		var value = parseInt(param.find('input').val()) + 1;
		param.find('input').attr('value', value);
	}
	function paramValueMinus(param){
		var value = parseInt(param.find('input').val()) - 1;
		if(value < 0){

		}else{
			param.find('input').attr('value', value);
		}
	}

	// product slider
	$('[data-slider-preview]').on('click', function(){
		$('[data-slider-preview]').removeClass("active");
		$(this).addClass("active");
		$('[data-slide]:visible').fadeOut(200);
		$('[data-slide='+ $(this).attr('data-slider-preview') +']').fadeIn(200);
	});

	// main slider
	var hwSlideSpeed = 700;
	var hwTimeOut = 5000;
	var hwNeedLinks = true;

	$('[data-main-slide]').css(
		{"position" : "absolute",
			"top":'0', "left": '0'}).hide().eq(0).show();

	$('[data-slider-wrap]').removeClass('hidden');
	var slideNum = 0;
	var slideTime;
	slideCount = $("[data-main-slider] [data-main-slide]").size();
	var animSlide = function(arrow){
		clearTimeout(slideTime);
		$('[data-main-slide]').eq(slideNum).fadeOut(hwSlideSpeed);
		if(arrow == "next"){
			if(slideNum == (slideCount-1)){slideNum=0;}
			else{slideNum++}
		}
		else if(arrow == "prew")
		{
			if(slideNum == 0){slideNum=slideCount-1;}
			else{slideNum-=1}
		}
		else{
			slideNum = arrow;
		}
		$('.slider-nav li').removeClass('active');
		$('.slider-nav li').eq(slideNum).addClass('active');
		$('[data-main-slide]').eq(slideNum).fadeIn(hwSlideSpeed, rotator);
		$(".control-slide.active").removeClass("active");
		$('.control-slide').eq(slideNum).addClass('active');
	};
	if(hwNeedLinks){
		var $linkArrow = $('<a id="prewbutton" href="#"></a><a id="nextbutton" href="#"></a>')
			.prependTo('[data-main-slider]');
		$('[data-main-slider-next]').click(function(){
			animSlide("next");

		});
		$('[data-main-slider-prew]').click(function(){
			animSlide("prew");
		})
	}
	var $adderSpan = '';
	$('[data-main-slide]').each(function(index) {
		$adderSpan += '<span class = "control-slide">' + index + '</span>';
	});
	$('<div class ="sli-links">' + $adderSpan +'</div>').appendTo('[data-slider-wrap]');
	$(".control-slide:first").addClass("active");

	$('.control-slide').click(function(){
		var goToNum = parseFloat($(this).text());
		animSlide(goToNum);
	});
	var pause = false;
	var rotator = function(){
		if(!pause){slideTime = setTimeout(function(){animSlide('next')}, hwTimeOut);}
	};
	$('[data-slider-wrap]').hover(
		function(){clearTimeout(slideTime); pause = true;},
		function(){pause = false; rotator();
	});
	$('.slider-nav a').click(function(event){
		event.preventDefault();
		var target = this.href.split("#")[1];
		animSlide(--target);
	});

	rotator();

	var seo_hide = 1;
	$(".seo_open a").on("click", function() {
		var $this = $(this);
		var $hide_block = $this.closest(".seo_block_footer").find(".seo_hide");
		if (seo_hide) {
			$hide_block.slideDown(200);
			seo_hide = 0;
			$this.html("свернуть");
		} else {
			$hide_block.slideUp(200);
			seo_hide = 1;
			$this.html("подробнее");
		}
	});


	// Метки
	var label_hide = 1;
	$(".labels-show-all").on('click', function() {
		var $this = $(this);
		var $hide_block = $this.closest(".labels").find(".extended");
		if (label_hide) {
			$hide_block.slideDown(200);
			label_hide = 0;
			$this.html("свернуть");
		} else {
			$hide_block.slideUp(200);
			label_hide = 1;
			$this.html("все теги");
		}
	});
});

function rUti_open(obj){
	$('[data-ruti].active').removeClass('active').find('[data-ruti-list]').hide(300, function(){
		$(this).closest('[data-ruti]').find('[data-ruti-min]').removeClass('active');
	});
	obj.addClass('active');
	obj.find('[data-ruti-list]').show(100);
}
function rUti_close(obj){
	obj.removeClass('active');
	obj.find('[data-ruti-list]').hide(300);
}

function printBlock() {
	PrintContent = $('#PrintContent').html();
	$('body').addClass('printSelected');
	$('body').append('<div class="printSelection">'+PrintContent+'</div>');
	window.print();
	window.setTimeout(pageCleaner,0);
	return false;
}
function pageCleaner(){
	$('body').removeClass('printSelected');
	$('.printSelection').remove();
}

function modal_open(id){
	if($('.overlay').is(':visible')){
		$('[data-modal]:visible').fadeOut(100, function(){
			$('[data-modal='+ id +']').fadeIn(200);
		});
	}else{
		$('.overlay').fadeIn(100, function(){
			$('[data-modal='+ id +']').fadeIn(200);
		});
	}
}
function modal_close(id){
	if(!id){
		$('[data-modal]').fadeOut(200, function(){
			$('.overlay').fadeOut(100);
		});
	}else{
		$('.overlay').fadeIn(100, function(){
			$('[data-modal='+ id +']').fadeIn(200);
		});
	}
}

/**
 * Проверка на обязательные поля в адресе
 * @return {boolean} - true/false
 */
function checkRequiredFields() {
	var req_fields = ['city', 'street', 'house_num'];
	var delivery   = $("input[name='id_delivery']:checked");

	var user_info = serializeForm($('.user-info')[0]);
	if (!user_info.name || !user_info.email || !user_info.phone || user_info.phone == '+7' || user_info.phone == '7')
		return false;

	// Самовывоз
	if (delivery.val() == 2) return true;

	var id_block = delivery.attr('id');
	var fields = serializeForm($("#delivery_" + id_block)[0]);

	for (var i = req_fields.length - 1; i >= 0; i--) {
		if (!fields[req_fields[i]] && fields[req_fields[i]] !== 0) {
			return false;
		}
	}

	return true;
}

$(document).ready(function() {
	var yaCounter25219640 = new Ya.Metrika({id: 25219640});

	$(document).on('click', '.cart-add-catalog', function () {
		yaCounter25219640.reachGoal('polojit_v_korzinu');
		ga('send', 'event', 'button_polojit_v_korzinu', 'click_polojit_v_korzinu');
	});

	$(document).on('click', '.counter-confirm-order', function() {
		yaCounter25219640.reachGoal('oformit_zakaz');
		ga('send', 'event', 'button_oformit_zakaz', 'click_oformit_zakaz');
	});

	$(document).on('click', '.counter-submit-order', function(){
		yaCounter25219640.reachGoal('potverdit_zakaz');
		ga('send', 'event', 'button_potverdit_zakaz', 'click_potverdit_zakaz');
	});

	$(document).on('click', '.counter-add-product', function(){
		yaCounter25219640.reachGoal('polojit_v_korzinu_2');
		ga('send', 'event', 'button_polojit_v_korzinu_2', 'click_polojit_v_korzinu_2');
	});

	window.dataLayer = window.dataLayer || [];

	// Добавление товара в корзину
	$(".add-to-cart, .buy-product").on("click", function() {
		var $this = $(this);
		$.post('/catalog/', { product_info: $this.data('id') }, function(json){
			var product = $.parseJSON(json);
			dataLayer.push({
				"ecommerce": {
					"add": {
						"products": [ product ]
					}
				}
			});
		});
	});

	// Покупка товара в один клик
	$(document).on('click', '.btn_buy_one_click', function () {
		var $this = $(this);
		$.post('/catalog/', { product_info: $this.data('id') }, function(json){
			var product = $.parseJSON(json);
			dataLayer.push({
				"ecommerce": {
					"purchase": {
						// "actionField": {
						// 	"id" : "TRX987",
						// 	"goal_id" : "1234567",
						// },
						"products": [ product ]
					}
				}
			});
		});
	});

	// Удаление товара из корзины
	$(document).on("click", ".delete", function() {
		var $this = $(this);
		$.post('/catalog/', { product_info: $this.data('id') }, function(json){
			var product = $.parseJSON(json);
			dataLayer.push({
				"ecommerce": {
					"remove": {
						"products": [
							product
						]
					}
				}
			});
		});
	});

	// Просмотр карточки товара
	if ($('.product-ecommerce-detail').length) {
		var $this = $('.product-ecommerce-detail');
		$.post('/catalog/', { product_info: $this.data('id') }, function(json){
			var product = $.parseJSON(json);
			dataLayer.push({
				"ecommerce": {
					"detail": {
						"products": [
							product
						]
					}
				}
			});
		});
	}

	// Если заказ был оформлен, то в input#user_order_name будет имя покупателя
	if ($('#user_order_name').length && $("#user_order_name").val()) {
		var id_order = $("#id_order").val();
		$.post('/shopcart/', { get_ecommerce_order_info: 1, id_order: id_order }, function(json){
			var order = $.parseJSON(json);
			dataLayer.push({
				"ecommerce": {
					"purchase": order
				}
			});
		});
	}
});

var listRU = $.masksSort($.masksLoad("/assets/js/json/phone_mask/phones-ru.json"), ['#'], /[0-9]|#/, "mask");
var optsRU = {
	inputmask: {
		definitions: {
			'#': {
				validator: "[0-9]",
				cardinality: 1
			}
		},
		//clearIncomplete: true,
		showMaskOnHover: false,
		autoUnmask: true
	},
	match: /[0-9]/,
	replace: '#',
	list: listRU,
	listKey: "mask",
	onMaskChange: function(maskObj, determined) {
		if (determined) {
			if (maskObj.type != "mobile") {
				//if (!$("#user_info #city").val()) {
				//  $("#user_info #city").val(maskObj.city.toString());
				//}
				//if (!$("#user_info #region").val()) {
				//  $("#user_info #region").val(maskObj.region.toString());
				//}
			}
		}
		$(this).attr("placeholder", $(this).inputmask("getemptymask"));
	}
};
$('.input_phone').inputmasks(optsRU);
if (!$('#phone').val())
	$('#phone').val('+7');
if (!$('#user_phone').val())
	$('#user_phone').val('+7');

/* main.js
 *
 * Скрипт вызывает основные действия страницы
 *
 */

$(document).ready(function() {

    shopCart = new ShopCart();

    $(".add-to-cart, .buy-product").on("click", function() {
		var d = shopCart.update($(this).data("id"));
		var $this = $(this);

		d.done(function() {
			if ($this.data('gotocart')) {
				window.location.href = '/shopcart/';
			} else {
				$.jGrowl("Товар добавлен в корзину");
			}
		});
    });

	spinnerLoad(shopCart);
	deleteCartProduct(shopCart);

	// Нужно ли нам считать доставку
	if ($("select").is("#delivery-variant")) {
		var total_price = parseFloat($(".white-price").html()) + 150;
		$(".price-icon-black-vbig").html(total_price);
		// Меняем цену при изменении
		$("#delivery-variant").on("change", function() {
			$(".price-icon-black-vbig").html(parseFloat($(".white-price").html()) + $("#delivery-variant :selected").data("price"));
		});
	}

	$(".mx_submit-order").on("click", function(){
		//$(this).closest("form").submit();
	});

	$('.order_pay').on('click', function() {
		var $this = $(this);
		if (!$this.hasClass('disabled')) {
			$this.addClass('disabled');
			$.post('/shopcart/', { order_register: 1, id_order: $('#id_order').val() }, function(data) {
				data = $.parseJSON(data);
				$this.removeClass('disabled');
				if (data !== null) {
					if (data.payment_link) {
						window.location.href = data.payment_link;
					} else if (data.errorCode) {
						$.jGrowl("Ошибка! Не удалось сформировать ссылку для оплаты заказа.");
						console.log(data.errorMessage);
					} else if (data.payment_limit) {
						$.jGrowl("Ошибка! Количество попыток для оплаты истекло.");
					}
				}
			});
		}
	});
});
// Загрузка spinner
function spinnerLoad(shopCart) {
	$(".counter .mx_plus").on("click", function(){
		var inp = $(this).parent().find("input");
		var c = inp.val();
		inp.val(parseInt(c) + 1);
		__updateCart(inp);
	});

	$(".counter .mx_minus").on("click", function(){
		var inp = $(this).parent().find("input");
		var c = inp.val();
		if (c == 1) {
			return;
		}
		inp.val(parseInt(c) - 1);
		__updateCart(inp);
	});

	function __updateCart(inp) {
		var id_product = inp.data("id");
		var count_product = inp.val();
		var id_model = inp.data('id_model');
		shopCart.update(id_product, count_product, id_model);
	}
}

function deleteCartProduct(shopCart) {
    $(document).on("click", ".delete", function() {
		shopCart.deleteProduct($(this).data("id"), this);
    });
}

$(document).ready(function() {
	var $model_list = $('.product-model .model-list');

	$('.product-model').on('click', function() {
		if ($model_list.hasClass('hidden'))
			$model_list.removeClass('hidden');
	});

	$('.product-model .model-list tr').on('click', function() {
		var $this = $(this);
		var model;

		setTimeout(function(){
			$model_list.addClass('hidden');
			$model_list.find('tr').removeClass('active');
			$this.addClass('active');

			_setModel();
		}, 10);
	});

	function _setModel() {
		model = $model_list.find('tr.active').data();

		// Скрываем изображения моделей в превью
		$(".img-model").hide();

		// // Показываем изображение выбранной модели в превью
		if ($("#img-model-" + model.id).length) {
			$('.product__preview .i-item').removeClass('active');
			$("#img-model-" + model.id).show().addClass('active');
		}

		// Показываем большое изображение модели, если оно есть
		if ($("#main-img-model-" + model.id).length) {
			$('.product__gallery .i-item').hide();
			$("#main-img-model-" + model.id).show();
		}

		$('.product-model .i-text > span').html(model.title);
		$('.i-price-value').html(model.price);
		$('.i-product-lot').html(model.lot);
		window.location.hash = model.id;
	}

	if ($model_list.length && window.location.hash) {
		var id_model = window.location.hash;
		id_model = id_model.replace('#', '');
		$model_list.find('tr').removeClass('active');
		$('[data-id="' + id_model + '"]').addClass('active');
		_setModel();
	} else if ($model_list.length) {
		_setModel();
	}

	$('body').on('click', function(e) {
		if (!$(e.toElement).closest('.product-model').length) {
			$model_list.addClass('hidden');
		}
	});
});

$(document).ready(function() {
	var $promoInput    = $(".promo-input-block .b-input input");     // инпут для ввода промокода
	var $icoFail       = $(".promo-input-block .ico-promo-fail");    // иконка о недействительном прокоде
	var $icoSuccess    = $(".promo-input-block .ico-promo-success"); // иконка об успешном применении промокода
	var $icoClosePromo = $(".ico-close-promo");

	/* Всплывающая информация-подсказка с описанием промокода */
	$(".promo-info").on("mouseenter", function () {
		$(".promo-info-text").fadeIn(150);
	});
	$(".promo-info").on("mouseout", function () {
		$(".promo-info-text").fadeOut(100);
	});

	// Разворачиваем поле для ввода промокодов
	$(".btn-have-promocode").on('click', function() {
		$(".promo-have-block").hide();
		$(".promo-input-block").show();
		$(".promo-input").addClass('in');
	});
	// Сворачиваем поле для ввода промокодов
	$(".btn-promo-hide").on('click', function() {
		$(".promo-have-block").show();
		$(".promo-input-block").hide();
		$(".promo-input").removeClass('in');
	});

	// При изменении текста в инпуте или фокусе на него показываем кнопку "Применить"
	$promoInput.on('textchange', onChangeInput);
	$promoInput.on('change', onChangeInput);
	$promoInput.on('focus', onChangeInput);

	function onChangeInput(){
		if (!$promoInput.attr("readonly")) {
			if ($promoInput.val()) {
				$(".btn-promo-hide").hide();
				$(".btn-promo-apply").show();
				$icoClosePromo.show();
			} else {
				$(".btn-promo-hide").show();
				$(".btn-promo-apply").hide();
				$icoClosePromo.hide();
			}
		} else if ($promoInput.hasClass('fail')) {
			cancelPromo.bind($icoClosePromo[0])();
		}
	}

	// Отмена промокода
	$icoClosePromo.on("click", function() {
		cancelPromo.bind(this)();
	});

	// Применение промокода
	$(".btn-promo-apply").on("click", function() {
		var $this = $(this);
		var code = $promoInput.val();
		var arg = {
			code: code,
			apply_promo: 1
		};

		$.post('/shopcart/', arg, function(json) {
			if (json !== null) {
				var data = $.parseJSON(json);
				$this.hide();
				if (data == 'success') {
					$icoSuccess.show();
					$promoInput.addClass('success');
				} else {
					$icoFail.show();
					$promoInput.addClass('fail');
				}
				$promoInput.attr("readonly", "readonly");
				$(".ico-close-promo").show();
			}
		});
	});
});

/**
 * Отмена промкода
 * @param  {boolean} post флаг, отменяющий выполнение POST-запроса к серверу
 */
function cancelPromo (post) {
	var $promoInput = $(".promo-input-block .b-input input");
	var $icoFail    = $(".promo-input-block .ico-promo-fail");
	var $icoSuccess = $(".promo-input-block .ico-promo-success");

	if (!$promoInput.length) return;

	if (!post && $promoInput.hasClass('success')) {
		$.post('/shopcart/', { cancel_promo: 1 });
	}

	if ($promoInput.val() === '') {
		$(".btn-promo-hide").show();
		$(".btn-promo-apply").hide();
		$(this).hide();
	} else {
		$(".btn-promo-apply").show();
	}

	if (!$promoInput.attr("readonly")) {
		$promoInput.val('').focus();
		$(this).hide();
		$(".btn-promo-hide").show();
		$(".btn-promo-apply").hide();
	}

	$icoFail.hide();
	$icoSuccess.hide();
	$promoInput.removeClass('success fail');
	$promoInput.removeAttr("readonly");
}

// Simple JavaScript Templating
// John Resig - http://ejohn.org/ - MIT Licensed
(function (){
  var cache = {};

  this.tmpl = function tmpl(str, data){
    // Figure out if we're getting a template, or if we need to
    // load the template - and be sure to cache the result.
    var fn = !/\W/.test(str) ?
        cache[str] = cache[str] ||
            tmpl(document.getElementById(str).innerHTML) :

      // Generate a reusable function that will serve as a template
      // generator (and which will be cached).
        new Function("obj",
            "var p=[],print=function(){p.push.apply(p,arguments);};" +

              // Introduce the data as local variables using with(){}
                "with(obj){p.push('" +

              // Convert the template into pure JavaScript
                str
                    .replace(/[\r\t\n]/g, " ")
                    .split("<%").join("\t")
                    .replace(/((^|%>)[^\t]*)'/g, "$1\r")
                    .replace(/\t=(.*?)%>/g, "',$1,'")
                    .split("\t").join("');")
                    .split("%>").join("p.push('")
                    .split("\r").join("\\'")
                + "');}return p.join('');");

    // Provide some basic currying to the user
    return data ? fn(data) : fn;
  };
})();
/*
 * Корзина (вызов через объект).
 *
*/

function ShopCart() {
	var script = "/shopcart/index.html";

	// Добовать товар в корзины
	this.update = function(id, count_product, id_model) {
		var d    = $.Deferred();
		shopCart = this;

		var arg = { id_product: id };

		// Если на странице есть блок с моделями, то вытаскиваем id выбранной модели
		if ($('.product-model').length) {
			arg.id_model = $('.product-model tr.active').data('id');
		} else if (id_model) {
			arg.id_model = id_model;
		}

		//  Если есть количество продуктов, тогда добавляем параметр
		if (count_product) arg.count_product = count_product;

		// Отменяем введенный промокод
		cancelPromo(true);

		$.post(
			script,
			arg,
			function(response){
				if (response !== null) $('.cart-order').html(response);
				if (count_product) shopCart.loadCart();
				d.resolve();
				_loadBlockCart();
			}
		);

		return d;
	};

	// Удаление товара из корзины
	this.deleteProduct = function(id_product, btn) {
		shopCart = this;

		// Отменяем введенный промокод
		cancelPromo(true);

		$.post(
			script,
			{
				id_product: id_product,
				delete_product: 1
			},
			function(response) {
				if (response !== null) $('.cart-order').html(response);

				if ((btn && !$(btn).hasClass("mx_fdel")) || $(".cart").length)
					shopCart.loadCart();

				_loadBlockCart();
			}
		);
	};

	// Загрузка корзины
	this.loadCart = function() {
		$(".cart-content").load(
			script,
			{
				cart_content: 1,
			},
			function () {
				spinnerLoad(shopCart);
				deleteCartProduct(shopCart);

				if (!$(".cart__item").length) {
					$(".main-content").html('<h3>Корзина пуста, воспользуйтесь <a href="/catalog/">каталогом</a> для совершения покупки.</h3>');
				}
			}
		);
	};

	function _loadBlockCart() {
		// Сворачиваем блок с корзиной справа
		var cart_block = $(".cart-block");
		cart_block.find('.mx_cart').css({
			display: "block",
			'z-index': 1000
		});

		var active = cart_block.find('[data-ruti-min]').hasClass('active');

		// Обновляем всплывающее окно с корзиной
		$.post(
			script,
			{
				update_cart_block: 1,
				active: active
			},
			function(response){
				if (response !== null){
					$(".cart-block").html(response);

					if (active) {
						cart_block.find('[data-ruti-min]').addClass('active');
						cart_block.find('[data-ruti-list]').show();
						cart_block.find(".mx_cart").addClass("active");
					}
				}
			}
		);
	}

	// Заказ в один клик
	this.confirmOrder = function(form, id_product) {
		var d = $.Deferred();
		shopCart = this;

		var arg = serializeForm(form);
		arg.simple_order = 1;
		arg.phone = $('.input_phone').data('value');
		arg.id_product   = id_product;

		// Если на странице есть блок с моделями, то вытаскиваем id выбранной модели
		if ($('.product-model').length) {
			arg.id_model = $('.product-model tr.active').data('id');
		}

		$.post(
			script,
			arg,
			function (json) {
				if (json !== null) {
					var hash = $.parseJSON(json);
					window.location.href = "/shopcart/order/" + hash;
				}

				// setTimeout(function(){ $('.overlay').fadeIn(10); }, 110);
				// $("#success_order__user").html(arg.name);
				// modal_open('success_order');
				d.resolve();
			}
		);

		return d;
	};
}
